const VUE_APP_API_MANAGE_URL = document.querySelector("body").getAttribute("api_manage_url");
console.log(VUE_APP_API_MANAGE_URL);
export default VUE_APP_API_MANAGE_URL
